export default __webpack_public_path__ + "img/dc607d29fa86159cd1ec03cbd7cdb2f6.png";